<template>
  <div id="preload-video">
    <video
        playsinline
        preload="auto"
        muted
    >
      <source type="video/webm">
      <source type="video/mp4">
    </video>
  </div>
</template>

<script>
export default {
  mounted() {
    this.setEventsVideo('canplaythrough', 'add', this.canplaythroughVideo)
    this.canplaythroughVideo()
  },
  destroyed() {
    this.setEventsVideo('canplaythrough', 'remove', this.canplaythroughVideo)
  },
  props: {
    videos: {
      default: () => []
    },
    position: Object
  },
  methods: {
    canplaythroughVideo() {
      if(this.videos.length !== this.position.loading) {
        let urls = this.createData()
        this.changeUrl(urls)
        this.position.loading++
      } else {
        this.$emit('complete')
      }
    },
    setEventsVideo(type, action, method) {
      if(document.getElementById('preload-video')) {
        let video = document.getElementById('preload-video').children[0]

        setTimeout(() => {
          if(video) {
            if(action === 'add') {
              video.addEventListener(type, method)
            } else {
              video.removeEventListener(type, method)
            }
          }
        }, 0)
      }
    },
    changeUrl(urls) {
      let video = document.getElementById('preload-video').children[0]
      let types = ['video/webm','video/mp4' ]

      for(let i = 0; i < 2; i++) {
        video.children[i].src = urls[i]
        video.children[i].type = types[i]
      }

      video.load()
    },
    createData() {
      let urls = [this.videos[this.position.loading].webm, this.videos[this.position.loading].video]
      return urls
    }
  }
}
</script>

<style scoped>

</style>